import Moment from 'moment'
import Vue from 'vue'

const datetime = (val) => {
  const time = Moment(val)
  return time.format('YYYY-MM-DD HH:mm:ss')
}

const dateMonth = (val) => {
  const time = Moment(val)
  return time.format('MM-DD')
}

const date = (val) => {
  const time = Moment(val)
  return time.format('YYYY-MM-DD')
}

const date2 = (val) => {
  const time = Moment(val)
  return time.format('YYYY年MM月DD日')
}

export {
  convertAuthor,datetime,date,date2,dateMonth,convertTree,deepCopy
}

// 深拷贝
function deepCopy(obj) {
  var result = Array.isArray(obj) ? [] : {};
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object') {
        result[key] = deepCopy(obj[key]);   //递归复制
      } else {
        result[key] = obj[key];
      }
    }
  }
  return result;
}



function convertTree (tree, map,mapRoute) {   //遍历数组
  // let result = []
  // 遍历 tree

  tree.forEach((item) => {
    // 读取 map 的键值映射
    let children = item[ map.children ]
    // 如果有子节点，递归
    if (children && children.length > 0) {
      children = convertTree(children, map, mapRoute)
    }
    if (item.funcUrl) {
      mapRoute.push({
        ...item
      })
    }
  })
  // return result
}


function convertAuthor (tree, userRoute) {  //1，所有路由表，2接口获取的初始化路由，路由筛选
  // 遍历 tree
  let result = []
  tree.forEach((item,index) => { // 自己的路由遍历
    let children = item.children
    if (children && children.length > 0) {
      children = convertAuthor(children, userRoute)
    }
    if (item.redirect) {
      result.push(item)
    }
    userRoute.forEach((rt) => {
      if(item.hidden){
        item.hidden = false;
        result.push({ ...item,})
      }
      if (rt.funcUrl.replace(/^\s*|\s*$/g,"") == item.path.replace(/^\s*|\s*$/g,"")) { // 自己的路由和后台的路由格式一样的话 在添加
        item.name = rt.funcName
        item.icon = rt.icon
        result.push({
          ...item,
          children: children || []
        })
      }
    })
  })
  return result
}







// WEBPACK FOOTER //
// ./src/common/js/util.js